import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueryParams } from "../../../models/queryParams/queryParams.model";
import { RootState } from "../../store";

// Define the initial state using that type
const initialState: QueryParams = {
  langParam: "",
  flow: "",
  resumeToken: "",
  crossSellingParameter: "",
  acquisitionpage: "",
  intcmp: "",
  medium: "",
};

export const QueryParamsSlice = createSlice({
  name: "queryParams",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setQueryParams: (
      _status: QueryParams,
      action: PayloadAction<QueryParams>
    ) => {
      return { ...action.payload };
    },
  },
});

export const { setQueryParams } = QueryParamsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectStatus = (state: RootState) => state;

export default QueryParamsSlice.reducer;
